import React from "react";
import GuideSection from "../components/guide/GuideSection";
import { nextStepsGuide } from "../components/guide/guideContent";
import { Container, Button } from "react-bootstrap";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import { useSelector } from "react-redux";
import { FiArrowRight, FiGrid } from "react-icons/fi";
import "./styles/options.css";

function Finalization() {
  const navigate = useNavigate();
  const currentStep = "Finalisation";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const isMobile = window.innerWidth <= 768;
  const cart = useSelector((state) => state.cart);

  return (
    <Container
      fluid
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        paddingLeft: "15px",
        paddingRight: "15px",
      }}
    >
      <Header />
      <Confetti
        width={isMobile ? window.innerWidth : window.innerWidth}
        height={isMobile ? window.innerHeight : window.innerHeight}
        numberOfPieces={100}
      />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <h4 className="my-3 mt-4">
        Félicitations ! Votre <span style={{ color: "#FF5500" }}>commande</span>{" "}
        a été validée.
      </h4>

      <div className="container mb-3 text-center" style={{ maxWidth: "800px" }}>
        <p className="text-lg mb-1">
          Nous avons bien reçu votre commande et un e-mail de confirmation vient
          de vous être envoyé.
        </p>
        <p className="text-lg mb-1">
          {/* Buttons */}
          <div className="d-flex justify-content-center mt-4 g-3 flex-column flex-sm-row">
            <div className="col-auto my-2">
              <Button
                variant="outline-primary"
                style={{
                  width: "200px",
                }}
                size="sm"
                className="me-3"
                onClick={() => navigate("/")}
              >
                Retourner à la page d'accueil
              </Button>
            </div>
            <div className="col-auto my-2">
              <Button
                style={{
                  backgroundColor: "#FF5500",
                  borderColor: "#FF5500",
                  width: "200px",
                }}
                size="sm"
                onClick={() => navigate("/user")}
              >
                Accéder au tableau de bord
              </Button>
            </div>
          </div>
        </p>
      </div>
      {cart?.from === "creation" && (
        <aside className="option-card erp-offer">
          <span className="option-icon" aria-hidden="true">
            <FiGrid />
          </span>
          <div className="erp-offer-text">
            <h2 className="option-title">
              Équipez votre entreprise avec Gestion 360°
            </h2>
            <p className="option-summary">
              Facturation, ressources humaines et relation client dans un ERP en
              ligne. Activez-le depuis votre espace dès que votre entreprise est
              créée.
            </p>
          </div>
          <button
            type="button"
            className="options-continue"
            onClick={() => navigate("/user/platformGest")}
          >
            Découvrir <FiArrowRight aria-hidden="true" />
          </button>
        </aside>
      )}

      <GuideSection {...nextStepsGuide} />
    </Container>
  );
}

export default Finalization;
